import { requestApi } from "@src/lib/axios";

export const thirdLogin = async (data: ILoginPrarm) => {
    return await requestApi<ILoginData>('/ChatLogicSvr/third/auth', {
        method: "POST",
        data
    })
}

export const thirdTempLogin = async (data: Pick<ITempLoginPrarm, 'org_key'>) => {
    return await requestApi<ILoginData>('/ChatLogicSvr/third/temp_auth', {
        method: "POST",
        data
    })
}

export interface ILoginPrarm {
    org_key: string;
    third_auth_code: string;
    third_auth_type: string;
    redirect_url: string
}

export interface ITempLoginPrarm {
    org_key: string;
    third_auth_type: string;
}


export interface ILoginData {
    exp: number;
    full_name: string;
    token: string;
    user_id: string;
    username: string
}